import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import captureError from '@disco/utils/captureError'

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      switch (process.env.NODE_ENV) {
        case 'development': {
          // Use local dynamic import in dev to support hot reloading
          return import(
            `../../frontend/assets/locales/${language}/${namespace}.json`
          ).catch(() => {
            console.error(
              '[i18n] could not load language/namespace in frontend/assets/locales',
              { language, namespace },
            )
          })
        }
        default: {
          const localesUrl = `https://static.disco.ac/disco-app/locales/${language}/${namespace}.json`

          return fetch(localesUrl)
            .then(res => {
              if (!res.ok) {
                throw new Error(`${res.status} ${res.statusText}`)
              }

              return res.json()
            })
            .catch(error => {
              captureError(error, {
                moduleName: 'i18n',
                description:
                  '[i18n] could not load language/namespace from locales CDN',
                extra: {
                  localesUrl,
                  language,
                  namespace,
                  error,
                },
              })
            })
        }
      }
    }),
  )
  .init({
    supportedLngs: ['en', 'ja'],
    returnEmptyString: false,
    fallbackLng: 'en',
    defaultNS: false,
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18next
